/// *** System import ***///
import { Component, ViewChild } from '@angular/core';
import { Platform, Nav, Events, ToastController, LoadingController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { RESOURCE_CACHE_PROVIDER } from '@angular/platform-browser-dynamic';
/// *** Custom import ***///
import { Globals } from './globals';
import { SessionProvider } from '../providers/session';
import { MainProcessProvider } from '../providers/processes/main';
/// *** Page import ***///
import { LoginPage } from '../pages/login/login';
import { Market_SessionPage } from '../pages/market/session/session';
import { Trading_OrderBookPage } from '../pages/trading/orderBook/orderBook';
import { Account_UserProfilePage } from '../pages/account/userProfile/userProfile';
import { Account_PortfolioPage } from '../pages/account/portfolio/portfolio';
import { Account_NewsPage } from '../pages/account/news/news';
import { Trading_OrderHistoryPage } from '../pages/trading/orderHistory/orderHistory';
import { Account_TransactionHistoryPage } from '../pages/account/transactionHistory/transactionHistory';
import { HelpPage } from '../pages/account/help/help';

@Component({
  selector: 'page-app',
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) private nav: Nav;
  private rootPage: any = LoginPage;
  private menuItems: Array<{
    name: string,
    title: string,
    icon: string,
    targetCompononent: any,
    hasBadge: boolean,
    isFooter: boolean
  }>;
  private activeMenuItem: any;
  constructor(
    // *** System
    private platform: Platform,
    private events: Events,
    private statusBar: StatusBar,
    private splashScreen: SplashScreen,
    private loadingController: LoadingController,
    private toastCtrl: ToastController,
    // *** Custom
    private globals: Globals,
    private session: SessionProvider,
    private mainProcess: MainProcessProvider) {
    this._initializeApp();
    this._eventSub();
    //this._initSession();
    this._prepareMenu();
  }

  // *** Initialiser l'application
  private _initializeApp() {
    this.platform.ready().then(
      (succeed) => {
        this.statusBar.styleDefault();
        this.splashScreen.hide();
      },
      (error) => { });
  }

  /// *** Définir le compte actif
  private _defineActiveAccount(account: any) {
    try {
      let loader = this.loadingController.create({
        content: this.globals.MSG_ACTIVE_ACCOUNT,
      });
      loader.present();
      this.session.data.activeAccount = account;
      this.session.persist().then(
        (succeed) => {
          this.mainProcess.defineActiveAccount(account);
          loader.dismiss();
        },
        (error) => { loader.dismiss(); });
    }
    catch (error) { this.globals.showUnknownError(this.toastCtrl, error); }
  }

  /// *** Ouvrir une page
  private _openPage(menuItem: any) {
    try {
      this.nav.setRoot(menuItem.targetCompononent).then(
        (succeed) => { this.activeMenuItem = menuItem; },
        (error) => { this.globals.showUnknownError(this.toastCtrl, error); });
    }
    catch (error) { this.globals.showUnknownError(this.toastCtrl, error); }
  }

  /// *** Se déconnecter
  private _logout() {
    try {
      let loader = this.loadingController.create({
        dismissOnPageChange: true,
        content: this.globals.MSG_LOGOUT,
      });
      loader.present();
      this.session.logout().then(
        (succeed) => {
          this.nav.setRoot(LoginPage).then(
            (succeed) => {
              this.activeMenuItem = this.menuItems[0];
            },
            (error) => {
              loader.dismiss();
              this.globals.showUnknownError(this.toastCtrl, error);
            });
        },
        (error) => { loader.dismiss(); }
      );
    }
    catch (error) { this.globals.showUnknownError(this.toastCtrl, error); }
  }


  //#region Page events





  //#endregion

  //#region Helpers
  /// *** S'inscrire aux évènements globaux
  private _eventSub() {
    try {
      // On valid session
      //this.events.subscribe('SessionProvider.validate', (userID) => { this.rootPage = Market_SessionPage; });
      // On server disconnect
      this.events.subscribe('MainHubProvider.disconnect', () => { this._logout(); });
    }
    catch (error) { this.globals.showUnknownError(this.toastCtrl, error); }
  }

  // *** Préparer les éléments du menu principal
  private _prepareMenu() {
    try {
      this.menuItems = [
        { name: 'Market', title: 'Marché', icon: 'bank', targetCompononent: Market_SessionPage, hasBadge: false, isFooter: false },
        { name: 'AccountPortfolio', title: 'Portefeuille', icon: 'suitcase', targetCompononent: Account_PortfolioPage, hasBadge: false, isFooter: false },
        { name: 'OrderBook', title: 'Carnet d\'ordres', icon: 'tasks', targetCompononent: Trading_OrderBookPage, hasBadge: false, isFooter: false },
        { name: 'OrderHistory', title: 'Historique des ordres', icon: 'history', targetCompononent: Trading_OrderHistoryPage, hasBadge: false, isFooter: false },
        { name: 'TransactionHistory', title: 'Relevé des opérations', icon: 'exchange', targetCompononent: Account_TransactionHistoryPage, hasBadge: false, isFooter: false },
        { name: 'News', title: 'News', icon: 'bell', targetCompononent: Account_NewsPage, hasBadge: true, isFooter: false },
        { name: 'UserProfile', title: 'Profil', icon: 'user', targetCompononent: Account_UserProfilePage, hasBadge: false, isFooter: false },
        { name: 'Help', title: 'Guide', icon: 'info-circle', targetCompononent: HelpPage, hasBadge: false, isFooter: false },
      ];
      this.activeMenuItem = this.menuItems[0];
    }
    catch (error) { this.globals.showUnknownError(this.toastCtrl, error); }
  }


  //#endregion
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts